import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { withLang } from "./withLang";

export const stripeApi = createApi({
  reducerPath: "stripeApi",
  baseQuery: withLang(
    fetchBaseQuery({
      baseUrl: `${process.env.REACT_APP_API_BASE_URL}/connectapi/`,
    }),
  ),
  endpoints: (builder) => ({
    connectStripe: builder.mutation({
      query: (body) => ({
        url: `stripe/account-onboarding`,
        method: "POST",
        body: body,
      }),
    }),
  }),
});

export const { useConnectStripeMutation } = stripeApi;
